"use strict";
/**
 * @module Session
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The buffer length os a session token
 */
exports.TOKEN_LENGTH = 24;
/**
 * A session token
 */
var SessionToken = /** @class */ (function () {
    /**
     * Create
     *
     * @param  {type} external: Buffer description
     * @return {type}                  description
     */
    function SessionToken(external) {
        this.external = external;
    }
    /**
     * Convert the token to a string
     *
     * @return the string representation of the token
     */
    SessionToken.prototype.toString = function () {
        return this.external.toString('ascii');
    };
    return SessionToken;
}());
exports.SessionToken = SessionToken;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/session/session-token.js
// module id = 1378
// module chunks = 1